(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["camaluma-confianca"] && !Shopify.designMode) return;
  try {
    // Diálogo do guia de medidas + recolhimento do bloco de presente.
  // O bloco de presente é um grupo montado no editor: em vez de duplicar os
  // campos (que carregam as line item properties do pedido), movemos o grupo
  // existente para dentro de um <details>, preservando inputs e estado.
  class CamalumaPdp {
    constructor(raiz) {
      this.raiz = raiz;
      this.ligarGuia();
      this.recolherPresente();
    }

    ligarGuia() {
      const dialogo = this.raiz.querySelector('[data-camaluma-guia]');
      if (!dialogo) return;

      this.raiz.querySelector('[data-camaluma-abre-guia]')?.addEventListener('click', () => {
        dialogo.showModal();
      });
      dialogo.querySelector('[data-camaluma-fecha-guia]')?.addEventListener('click', () => {
        dialogo.close();
      });
      dialogo.addEventListener('click', (evento) => {
        if (evento.target === dialogo) dialogo.close();
      });
    }

    recolherPresente() {
      const campo = document.querySelector('[id*="__presente_sacola"]');
      const grupo = campo?.closest('.group-block');
      if (!grupo || grupo.dataset.camalumaRecolhido === 'true') return;

      const titulo = grupo.querySelector('[class*="__presente_titulo"]');
      const rotulo = titulo?.textContent.trim() || 'Presenteie com carinho';
      titulo?.remove();

      const caixa = document.createElement('details');
      caixa.className = 'camaluma-presente-caixa';
      caixa.innerHTML =
        '<summary class="camaluma-presente-caixa__resumo">' +
        '<span>' + rotulo + '</span>' +
        '<span class="camaluma-presente-caixa__dica">sacola, cartão e tag De/Para</span>' +
        '</summary>';

      grupo.parentElement.insertBefore(caixa, grupo);
      caixa.appendChild(grupo);
      grupo.dataset.camalumaRecolhido = 'true';
    }
  }

  document.querySelectorAll('.camaluma-confianca').forEach((raiz) => new CamalumaPdp(raiz));
  } catch(e) { console.error(e); }
})();

})();
